// src/components/molecules/PayPalPayment.js
import React from "react";
import { Box } from "@mui/material";
import { PayPalButtons } from "@paypal/react-paypal-js";
import CustomCard from "./ChallengeCreator/CustomCard";

const PayPalPayment = ({
  submissionFee,
  onPaymentSuccess,
  onPaymentError,
  setSnackbarMessage,
  setSnackbarOpen,
  setShowPayPalButtons,
  theme,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: theme.colors.mediumPurple,
        borderRadius: "10px",
      }}
    >
      <CustomCard
        title={`Submission Fee Payment of $${submissionFee} required`}
      >
        <PayPalButtons
          createOrder={(data, actions) => {
            const fee = parseFloat(submissionFee) || 0;

            if (fee <= 0) {
              setSnackbarMessage("Invalid submission fee amount.");
              setSnackbarOpen(true);
              return;
            }

            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: fee.toFixed(2),
                  },
                },
              ],
            });
          }}
          onApprove={async (data, actions) => {
            try {
              const capture = await actions.order.capture();
              console.log("Payment successful:", capture);
              setShowPayPalButtons(false);
              await onPaymentSuccess(capture); // Handle the payment success outside the component
            } catch (error) {
              console.error("Payment failed:", error);
              setSnackbarMessage(
                "An error occurred during payment. Please try again."
              );
              setSnackbarOpen(true);
            }
          }}
          onError={(err) => {
            console.error("PayPal error:", err);
            setSnackbarMessage(
              "An error occurred with PayPal. Please try again."
            );
            setSnackbarOpen(true);
            onPaymentError && onPaymentError(err); // Handle the payment error outside the component
          }}
        />
      </CustomCard>
    </Box>
  );
};

export default PayPalPayment;